import * as stylex from "@stylexjs/stylex";
import { colors, fonts, fontSizes } from "@softmax/design-system/tokens.stylex";

export function StorefrontLead({ game }: { readonly game?: string }) {
  const gameName = game ?? "this game";
  return (
    <p {...stylex.props(styles.lead)}>
      {`Tell your AI coding assistant how you want to play ${gameName}. It writes a bot that plays matches for you. Review the results and ask your assistant to improve your bot between matches.`}
    </p>
  );
}

const styles = stylex.create({
  lead: {
    margin: 0,
    fontFamily: fonts.sans,
    fontSize: {
      default: fontSizes.body,
      "@container (min-width: 880px)": fontSizes.sectionTitle,
    },
    lineHeight: { default: 1.5, "@container (min-width: 880px)": 1.6 },
    color: colors.foreground,
  },
});
